<template>
    <div>
      <common-dialog
        ref="dialog"
        width="700px"
        :show-save-button="$permission.canEdit()"
        unit="购物须知"
        edit-title
        id-key="RecordId"
        :data="data"
        form-label-width="85px"
        :form-rules="rules"
        :save-func="api.save"
        @create-opened="onCreateOpened"
        @edit-opened="onEditOpened"
        close-on-saved
        :before-save="onBeforeSave"
        :get-data-func="api.info"
        @closed="onClosed"
        @close-saved="$emit('close-saved')"
      >
        <template slot="form">
          <el-row>
            <el-col :span="24">
              <el-form-item label="模板名称" prop="NoticeName">
                <el-input v-model="data.NoticeName" placeholder="请填写模板名称" clearable></el-input>
              </el-form-item>
            </el-col>
           
          </el-row>
                
          <el-row>
            <el-col :span="24">
              <el-form-item label="图片上传" prop="PhotoAddress">
                <single-pic-upload
                  v-model="data.PhotoAddress"
                  type="PhotoAddress"
                  :uploadUrl="uploadUrl"
                ></single-pic-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:12">
              <el-form-item label="序号" prop="OrderId">
                <el-input-number v-model="data.OrderId" :min="0" />
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:12">
              <el-form-item label="状态" prop="State">
                <el-radio-group v-model="data.State">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template #footer v-if="!$permission.canEdit()">
           <el-button @click="close">关 闭</el-button>
       </template>
      </common-dialog>
    </div>
  </template>
  <script>
  import editDialogMixin from "@/mixins/editDialog";
  import commonDialog from "@/components/common/dialog";
  import singlePicUpload from "@/components/common/photo/singleUpload";
  
  export default {
    mixins: [editDialogMixin],
    components: {
      commonDialog,
      singlePicUpload
    },
    data() {
      return {
        data: {
          RecordId: 0,
          NoticeName: "",
          PhotoAddress: "",
          OrderId: 0,
          State: 1,
          },
       
        api: require("@/api/sale/notice").default,
      
        isMB: this.$store.state.isMB,
        rules: {
            NoticeName: [{ required: true, message: "模板名称不能为空" }],
            PhotoAddress: [{ required: true, message: "请上传图片" }],
         
          
          OrderId: [{ required: true, message: "序号不能为空" }],
        },
        uploadUrl: "/api/Common/UploadPicture",
      };
    },
    methods: {
      onCreateOpened(row) {
             
        this.api.getMaxOrderId().then(res => {
          if(res.Code==0) this.data.OrderId = res.Data;
        })
      },
      onEditOpened(row) {
        
    },
    onBeforeSave() {
      
    },
    onClosed() {

    },
    },
  };
  </script>